import React, { memo } from 'react';
import { get } from 'lodash';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_CUSTOMER_PROMO, LINE_ITEM_INITIAL_PAYMENT, LINE_ITEM_PREMIUM_PROCESSING_FEE_DISCOUNT } from '../../util/types';

import css from './BookingBreakdown.css';

const LineItemOriginalTotal = memo(props => {
  const { intl, transaction } = props;

  const initialPayment = transaction && transaction.attributes.protectedData.initialPayment/100;
  const formattedTotal = initialPayment ? initialPayment.toFixed(2) : '';
  const totalToPositiveAmount = formattedTotal ? Math.abs(formattedTotal) : '';

  // Detect promo and Miles Club from original trip line items (stored as JSON in initialTx)
  const { promoAmount, milesClubAmount } = (() => {
    try {
      const lineItemsStr = get(transaction, 'attributes.protectedData.initialTx.attributes.lineItems');
      if (!lineItemsStr) return { promoAmount: 0, milesClubAmount: 0 };
      const lineItems = JSON.parse(lineItemsStr);
      const promoItem = lineItems.find(item => item.code === LINE_ITEM_CUSTOMER_PROMO);
      const milesClubItem = lineItems.find(item => item.code === LINE_ITEM_PREMIUM_PROCESSING_FEE_DISCOUNT);
      return {
        promoAmount: promoItem ? Math.abs(get(promoItem, 'unitPrice.amount', 0)) / 100 : 0,
        milesClubAmount: milesClubItem ? Math.abs(get(milesClubItem, 'unitPrice.amount', 0)) / 100 : 0,
      };
    } catch (e) {
      return { promoAmount: 0, milesClubAmount: 0 };
    }
  })();
  const totalGrossUp = promoAmount + milesClubAmount;

  return (
    <div className={css.lineItem}>
      <hr className={css.totalDivider} />

      <span className={css.itemTotalLabel}>Total</span>

      <span className={css.itemTotalValue}>{totalToPositiveAmount}</span>

      {totalGrossUp > 0 && (
        <p className={css.promoNote}>
          Includes SGD {totalGrossUp.toFixed(2)} in discounts (
          {[
            promoAmount > 0 && `promo SGD ${promoAmount.toFixed(2)}`,
            milesClubAmount > 0 && `Miles Club SGD ${milesClubAmount.toFixed(2)}`,
          ].filter(Boolean).join(' + ')}
          ) from your original booking
        </p>
      )}
    </div>
  );
});

export default LineItemOriginalTotal;
